import React from "react";
import {ChipLabel} from "./index";

const MaSourceChips = ({source}) => {
    return (
        <React.Fragment>
            {
                source === 'blueprint' && <ChipLabel label={"Blueprint"} className={"data-access-chip primary"}/>
            }
            {
                source === 'family_office' && <ChipLabel label={"Family Office"} className={"data-access-chip secondary"}/>
            }
            {
                source === 'ia_ma_transaction' && <ChipLabel label={"AI From News"} className={"data-access-chip advocate"}/>
            }
            {
                source === 'ma_transaction' && <ChipLabel label={"M&A Transaction"} className={"data-access-chip none"}/>
            }
        </React.Fragment>
    )
}

export default MaSourceChips;